var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MainHeader'),_c('SubHeader'),_c('main',[_c('router-view'),_c('CalendarAside')],1),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }